/**
 * Maximum number of search query suggestions to show in search suggestion results.
 */ export var MAX_NUM_SEARCH_QUERY_SUGGESTIONS_CONFIG = 'MAX_NUM_SEARCH_QUERY_SUGGESTIONS_CONFIG';
